module.exports = __webpack_public_path__ + "img/skinmask_step3.19061214.jpg";